import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"height":"calc(100vh - 20rem)","background-color":"white","overflow-y":"scroll"},
  class: "m-4"
}
const _hoisted_2 = { class: "w-25" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "fs-6 fw-lighter" }
const _hoisted_5 = { class: "w-75" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = ["innerHTML"]

import {  onMounted, Ref, ref } from 'vue';
import CoreDialog from '../../../framework/components/dialog/CoreDialog.vue';
import { dayjs, DT_FORMAT } from '../../../framework/util/momentExtends';
import { NotifyMessage } from '../../../server/dto/generated/NotifyMessage';
import { NotifyMessageService } from '../../biz/remote/NotifyMessageService';
import { translation } from '../../lang/Translation';
import { DialogHandler } from './DialogHandler';
import { SessionMemory } from '../../utils/SessionMemory';
import { LocalMemory } from '../../utils/LocalMemory';
import Notifications from '@kyvg/vue3-notification';

/**
 * 動的ラベル
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationDialog',
  setup(__props) {

const t = translation
const title = t.to('おしらせ',"notice");
const closeTitle = t.to("閉じる","close")
const selectedItem: Ref<NotifyMessage> = ref(null);
const selectNotify = (item: NotifyMessage) => {
  selectedItem.value = item;
};

/**
 * プロパティ
 */
const notifications = ref([] as NotifyMessage[]);

const getMaxDt = (items:NotifyMessage[])=>{
  return items.reduce((prev,current)=> current.notify_dt > prev.notify_dt ? current : prev)
}

const dialogId = DialogHandler.notificationId;
const biz = new NotifyMessageService();
onMounted(() => {
  DialogHandler.onOpenDialog(dialogId, async () => {
    LocalMemory.instance.setLocal("last_notification_dt",new Date().toLocaleString())

    const response = await biz.selectAll();
    notifications.value = response.data.sort((a,b)=>a.notify_dt > b.notify_dt ? -1:1);
    console.log(response.data)
    
    // データがなかったら終わり
    if(notifications.value.length < 1){ return }
    LocalMemory.instance.setLocal("last_notification_dt",getMaxDt(notifications.value).notify_dt.toLocaleString())
  });
});
const formatDt = (dt: Date) => {
  return dayjs(dt).format(DT_FORMAT);
};
const fromNow = (dt: Date) => {
  return dayjs(dt).fromNow();
};
const close = ()=>{
  DialogHandler.hideDialog(DialogHandler.notificationId)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    "dialog-class": { 'modal-xl': true },
    title: _unref(title)
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn btn-primary btn-lg",
        onClick: close
      }, _toDisplayString(_unref(closeTitle)), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.notify_id,
            class: "d-flex"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "fs-5 fw-lighter",
                onClick: ($event: any) => (selectNotify(item))
              }, _toDisplayString(item.title), 9, _hoisted_3),
              _createElementVNode("div", _hoisted_4, _toDisplayString(formatDt(item.notify_dt)) + " (" + _toDisplayString(fromNow(item.notify_dt)) + ")", 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "fs-5 fw-lighter",
                  innerHTML: item.notify_message.replace(/\n/g,'<br />')
                }, null, 8, _hoisted_7)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})